<div class="d-flex justify-content-between">
    <h5 class="fw-semibold ms-2 ">Engine Parameter</h5>
    <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
        (click)="onNoClick()">
</div>
<div>

    <div class="io-naming-box ms-2 me-2">
        <div> Digitaler Eingang 1</div> <input matInput type="text" class="form-control"
            placeholder="Digitaler Eingang 1" [(ngModel)]="digitalInput1" name="digitalInput1">
        <section class="example-section">
            <mat-checkbox class="example-margin" [(ngModel)]="isDigitalInput1Selected">Abfragen</mat-checkbox>
        </section>
    </div>
    <div class="io-naming-box  ms-2 me-2">
        <div> Digitaler Eingang 2</div> <input matInput type="text" class="form-control"
            placeholder="Digitaler Eingang 2" [(ngModel)]="digitalInput2" name="digitalInput2">
        <section class="example-section">
            <mat-checkbox class="example-margin" [(ngModel)]="isDigitalInput2Selected">Abfragen</mat-checkbox>
        </section>
    </div>
    <div class="io-naming-box  ms-2 me-2">
        <div> Digitaler Eingang 3</div> <input matInput type="text" class="form-control"
            placeholder="Digitaler Eingang 3" [(ngModel)]="digitalInput3" name="digitalInput3">
        <section class="example-section">
            <mat-checkbox class="example-margin" [(ngModel)]="isDigitalInput3Selected">Abfragen</mat-checkbox>
        </section>
    </div>
    <div class="io-naming-box  ms-2 me-2">
        <div> Digitaler Eingang 4</div> <input matInput type="text" class="form-control"
            placeholder="Digitaler Eingang 4" [(ngModel)]="digitalInput4" name="digitalInput4">
        <section class="example-section">
            <mat-checkbox class="example-margin" [(ngModel)]="isDigitalInput4Selected">Abfragen</mat-checkbox>
        </section>
    </div>
    <div class="io-naming-box  ms-2 me-2">
        <div> Digitaler Ausgang 1</div> <input matInput type="text" class="form-control"
            placeholder="Digitaler Eingang 5" [(ngModel)]="digitalOutput1" name="digitalInput5">
        <section class="example-section">
            <mat-checkbox class="example-margin" [(ngModel)]="isDigitalOutput1Selected">Abfragen</mat-checkbox>
        </section>
    </div>

</div>
<div>
    <div class="d-flex justify-content-between border-top w-100">
        <button class="btn btn-sm btn-outline-danger  rounded-0" (click)="onNoClick()">
            Schließen
        </button>
        <button class="btn btn-sm btn-primary rounded-0" (click)="onYesClick()">Speichern</button>

    </div>
</div>